import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f203046e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-leading-[100%] tw-flex-col tw-justify-center tw-items-start tw-rounded-[6px] tw-pt-[25px] question-body" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[10px] tw-pb-[10px] tw-px-[25px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-medium tw-leading-[145%]" }
const _hoisted_4 = { class: "tw-px-[25px] tw-pb-[25px] description-body" }
const _hoisted_5 = { class: "tw-text-[13px] tw-font-normal tw-text-[#878787]" }
const _hoisted_6 = {
  key: 0,
  class: "tw-px-[25px] tw-pb-[25px]"
}
const _hoisted_7 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[12px] tw-mb-[13px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_8 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }
const _hoisted_9 = { class: "tw-mb-[25px] tw-pt-[12px] tw-leading-[100%]" }
const _hoisted_10 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-medium" }

import { ref, watch } from "vue";
import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import QuestionPage from "./questionPage.vue";
import { WIZARD_STATE_NAME, wizardQuestionAnswerType } from "@/utils/constants";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME, statusPage } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import ButtonAddAnother from "./buttonAddAnother.vue";
import store from "@/store";
import { computed } from "vue";
import ListDomain from "./listDomain.vue";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardQuestions',
  props: {
  titleQuestion: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  questionType: {
    type: String,
    default: wizardQuestionAnswerType.radio,
  },
  dropdownData: {
    type: Array,
    default: () => [],
  },
  isHaveSubDecription: {
    type: Boolean,
    default: false,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: ["onUpdate", "check:answer", "update:answer"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

const currentOrg = computed(() => store.state.Org.currentOrg);

const currentValue = ref(0);
const listDomainRef: any = ref([]);

const domains = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.domains[0]?.values) {
    return setupWizard.questions[currentOrg.value.id].domains[0].values.map(
      (el) => ({
        ...el,
        showAccordion: false,
      }),
    );
  } else {
    return [];
  }
});

const isDomainName = computed(() => {
  const setupWizard = store.state.SetupWizard;
  if (setupWizard.questions[currentOrg.value.id]?.domains[0]?.values) {
    const isDomainName = setupWizard.questions[
      currentOrg.value.id
    ].domains[0].values.some((item) => item.id && !item.isArchived);
    return isDomainName ? 1 : "";
  } else {
    return "";
  }
});

const route = useRoute();

onMounted(() => {
  const queryValue = route.query?.type;
  if (queryValue === WIZARD_STATE_NAME.DOMAINS) {
    addAnother();
    setTimeout(() => {
      document
        .getElementById(`input-domain-${domains.value.length - 1}`)
        ?.focus();
    }, 500);
  }
});

const addAnother = () => {
  const objAdd = {
    id: "",
    domainName: "",
    domainRegistrarId: null,
    domainRegistrar: null,
    startDate: new Date(),
    description: null,
    notes: null,
    endDate: null,
    showAccordion: false,
    isEdit: true,
    isArchived: false,
  };
  domains.value.forEach((item) => (item.showAccordion = false));
  store.commit("SetupWizard/SET_DOMAIN_NAME_PUSH", {
    objAdd,
    currentOrg: currentOrg.value.id,
  });
  // emits("changeStatusAddDomain", true);
};



watch(props.statusInPage, (value) => {
  if (
    (value.statusPage === statusPage.CallApi ||
      value.statusPage === statusPage.Error) &&
    (props.statusInPage.dataError.length > 1 ||
      (props.statusInPage.dataError.length === 1 &&
        !props.statusInPage.dataError[0].endDate))
  ) {
    domains.value.forEach((item, index) => {
      store.commit("SetupWizard/SET_DOMAIN_NAME", {
        value: { ...item, isCallAPI: true },
        _index: index,
        currentOrg: currentOrg.value.id,
      });
    });
  }
});

const handleAnswer = (answer: any) => {
  currentValue.value = answer;
  emits("update:answer", answer);
  emits("onUpdate", answer);
};

const openModalMoreInfor = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_WIZARD_MORE_INFO,
    properties: {
      isMoreInfoModal: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const checkAllValidations = async () => {
  let isAllValid = true,
    listDoamins = [] as any[];
  for (let index = 0; index < listDomainRef.value.length; index++) {
    const test = await listDomainRef.value[index].saveChanges();
    if (!test) {
      isAllValid = false;
    }
    listDoamins.push(test.finalValue);
  }
  return isAllValid;
};

__expose({
  checkAllValidations,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.description), 1),
      (__props.isHaveSubDecription)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "tw-text-[13px] tw-font-medium tw-leading-[100%] tw-text-[#387DFF] tw-pl-[4px] tw-cursor-pointer hover:tw-opacity-80",
            onClick: openModalMoreInfor
          }, _toDisplayString(_unref(getComponentUiText)(
            "app-menu-submenu-home-setup-wizard-domains-page-sub-title-2",
          )), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(QuestionPage, {
      title: __props.titleQuestion,
      "border-select": true,
      "question-type": __props.questionType,
      "dropdown-data": __props.dropdownData,
      "is-true": isDomainName.value,
      "onUpdate:answer": handleAnswer
    }, null, 8, ["title", "question-type", "dropdown-data", "is-true"]),
    (currentValue.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (
          __props.statusInPage.statusPage === _unref(statusPage).Error &&
          __props.statusInPage.errorMessage
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(WarningIcon, { color: "#F7553C" }),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: __props.statusInPage.errorMessage
                  ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                  : "",
              },
            )), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)("app-menu-submenu-home-setup-wizard-sites-note-1")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domains.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${index}`
            }, [
              _createVNode(ListDomain, {
                ref_for: true,
                ref_key: "listDomainRef",
                ref: listDomainRef,
                item: item,
                "current-index": index,
                "status-in-page": __props.statusInPage,
                data: { item, index },
                onChangeStatusAddDomain: _cache[0] || (_cache[0] = ($event: any) => (
            emits('onUpdate', $event), checkAllValidations
          ))
              }, null, 8, ["item", "current-index", "status-in-page", "data"])
            ]))
          }), 128)),
          _createVNode(ButtonAddAnother, { onClick: addAnother })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})